import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from '../constants';
export const initialFormState = {
  errors: {
    isCardExpired: false
  }
};
export const initialPayInMethodsState = {
  ui: UiState.Idle,
  payInMethods: []
};
export const initialState = {
  formState: initialFormState,
  isCardSingleUseOverriden: false,
  payInMethodsState: initialPayInMethodsState
};

const setIsCardExpired = (draft, action) => {
  draft.formState.errors.isCardExpired = action.payload.isExpired;
};

const setIsCardSingleUseOverriden = (draft, action) => {
  draft.isCardSingleUseOverriden = action.payload.overrideSingleUse;
};

const handleCardAddAuthResult = (draft, action) => {
  const {
    cardAddResult
  } = action.payload;
  draft.cardAddAuth = {
    cardAddResult
  };
};

const fetchPayInMethodsRequest = draft => {
  draft.payInMethodsState.ui = UiState.Pending;
};

const fetchPayInMethodsFailure = draft => {
  draft.payInMethodsState.ui = UiState.Failure;
};

const fetchPayInMethodsSuccess = (draft, action) => {
  draft.payInMethodsState.ui = UiState.Success;
  draft.payInMethodsState.payInMethods = action.payload.payInMethods;
};

const paymentSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    setIsCardExpired,
    handleCardAddAuthResult,
    fetchPayInMethodsRequest,
    fetchPayInMethodsFailure,
    fetchPayInMethodsSuccess,
    setIsCardSingleUseOverriden
  }
});
export const {
  actions
} = paymentSlice;
export const plug = {
  [stateName]: paymentSlice.reducer
};
export default paymentSlice.reducer;